import React from "react";
import s from "./index.module.scss";
import { Button } from "@masonite/external-ui-react";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";
import { language } from "utility/env";

const cx = classNames.bind(s);

const Page = ({ page, pathname, current = false }) =>
  current ? (
    <span className={cx(["page", "page--current"])}>{page}</span>
  ) : (
    <Link
      to={{ pathname, search: page > 1 ? `?p=${page}` : "" }}
      className={cx(["page"])}
    >
      {page}
    </Link>
  );

const Pagination = props => {
  const {
    current_page: currentPage,
    last_page: lastPage,
    per_page: perPage,
    total,
    action,
    pathname,
    distanceFromCurrentPage = 2
  } = props;

  const nextPage = currentPage + 1;

  const prevPage = currentPage - 1;

  const [previousPages, nextPages] = [
    -distanceFromCurrentPage,
    distanceFromCurrentPage
  ].map(d =>
    [...Array(distanceFromCurrentPage).keys()]
      .map(i => {
        const offset = d <= 0 ? -(i + 1) : i + 1;
        const page = currentPage + offset;
        return page > 0 && page <= lastPage ? (
          <Page key={page} pathname={pathname} page={page} />
        ) : (
          false
        );
      })
      .filter(v => v)
  );

  return (
    total > perPage && (
      <div className={s.pagination}>
        {currentPage > 1 && (
          <Button variant="light" onClick={() => action(prevPage)}>
            { language === "fr" ? "Précédente" : "Prev" }
          </Button>
        )}
        <div className={s.pages}>
          {previousPages.reverse()}
          <Page page={currentPage} current />
          {nextPages}
        </div>
        {nextPage <= lastPage && (
          <Button variant="light" size="small" onClick={() => action(nextPage)}>
            { language === "fr" ? "Suivante" : "Next" }
          </Button>
        )}
      </div>
    )
  );
};

export default Pagination;
